var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EditCampaignBudgetModal',{attrs:{"value":_vm.value,"available-budget":_vm.availableBudget,"is-loading":_vm.isLoading,"credit":_vm.credit,"budget-allocation-limit":_vm.budgetAllocationLimit},on:{"input":_vm.changeModalVisibility,"submit":_vm.changeBudget}})
}
var staticRenderFns = []

export { render, staticRenderFns }